import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgShimmer',
})
export default class CmgShimmer extends Vue {
  @Prop({ required: false, default: 'top' })
  position!: 'bottom' | 'top';

  @Prop({ default: 'beige', type: String })
  color!: string;

  @Prop({ default: false, type: Boolean })
  dark!: boolean;
}
